/**
 * Whether program-configuration grants the airport_transfer benefit for a tier
 * (independent of the loyalty account API benefits array).
 */
function configGrantsAirportTransferForTier(
  config: App.LoyaltyConfig | undefined,
  tier: App.LoyaltyTier | undefined,
): boolean {
  if (!config || !tier) return false
  if (!config.regionEnabledBenefits.airport_transfer) return false
  return config.regionTierBenefits[tier]?.some(b => b.code === 'airport_transfer') ?? false
}

export default configGrantsAirportTransferForTier
